/**
 * Cart
 */

export const cart = {
    namespaced: true,
    state: () => ({
        items: [],
        groups: {},
        amount: 0,
        oldAmount: 0,
        hasUnavailable: null,
    }),
    mutations: {
        setCart: (state, payload) => {
            state.items = [...payload.items];
            state.groups = { ...payload.groups };
            state.amount = parseFloat(payload.amount);
            state.oldAmount = parseFloat(payload.oldAmount);
            state.hasUnavailable = payload.hasUnavailable;
        },

        setQty: (state, payload) => {
            state.items = state.items.map((item, index) => {
                let set = payload.set_id ? payload.set_id : 0
                if (item.id == payload.id && item.set_id == set) {
                    item.qty = payload.qty;
                }

                return item;
            });
        }
    },
    actions: {
        getCart: ({ commit }, payload) => {
            let params = {};

            // Если выбран плательщик, добавляем параметр в запрос
            if (typeof payload !== 'undefined' && typeof payload.payer !== 'undefined') {
                params.payer = payload.payer
            }

            axios.get('/ajax/cart', { params: params })
                .then(request => {
                    commit('setCart', {
                        ...request.data,
                        amount: parseFloat(request.data.amount),
                        oldAmount: parseFloat(request.data.old_amount),
                        hasUnavailable: request.data.has_unavailable
                    });
                });
        },

        addToCart: ({ dispatch }, payload) => {
            let params = {
                id: payload.id,
                qty: payload.qty,
            };

            if (typeof payload.set !== 'undefined') {
                params.set = payload.set;
            }

            axios.post('/ajax/cart/add', params)
                .then(request => {
                    dispatch('getCart');

                    let products = [];

                    for (let i = 0; i < request.data.items.length; i++) {
                        products[i] =  {
                            "id": request.data.items[i].sku,
                            "name": request.data.items[i].title,
                            "price": request.data.items[i].price,
                            "category": request.data.items[i].category,
                            "quantity": request.data.items[i].qty
                        };
                    }

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",    
                            "add": {
                                "products": products
                            }
                        }
                    });
                });
        },

        deleteFromCart: ({ commit, dispatch }, payload) => {
            axios.delete('/ajax/cart/delete/' + payload.id + (payload.set ? '/' + payload.set : ''))
                .then(request => {
                    dispatch('getCart');

                    let products = [];

                    for (let i = 0; i < request.data.items.length; i++) {
                        products[i] =  {
                            "id": request.data.items[i].sku,
                            "name": request.data.items[i].title,
                            "price": request.data.items[i].price,
                            "category": request.data.items[i].category,
                            "quantity": request.data.items[i].qty
                        };
                    }

                    // metrika
                    window.dataLayer = window.dataLayer || [];
        
                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "remove": {
                                "products": products
                            }
                        }
                    });
                });
        },

        plus: ({ commit, dispatch }, payload) => {
            // let params = {
            //     id: payload
            // };

            axios.put('/ajax/cart/plus', payload)
                .then(request => {
                    commit('setQty', { id: payload.id, set_id: payload.set_id, qty: request.data.totalQty });
                    dispatch('getCart'); 
                    
                    let products =  [{
                        "id": request.data.sku,
                        "name": request.data.title,
                        "price": request.data.price,
                        "category": request.data.category,
                        "quantity": request.data.qty
                    }];

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",    
                            "add": {
                                "products": products
                            }
                        }
                    });
                });
        },

        minus: ({ commit, dispatch }, payload) => {
            // let params = {
            //     id: payload
            // };

            axios.put('/ajax/cart/minus', payload)
                .then(request => {
                    commit('setQty', { id: payload.id, set_id: payload.set_id, qty: request.data.totalQty });
                    dispatch('getCart');
                    
                    let products =  [{
                        "id": request.data.sku,
                        "name": request.data.title,
                        "price": request.data.price,
                        "category": request.data.category,
                        "quantity": request.data.qty
                    }];

                    // metrika
                    window.dataLayer = window.dataLayer || [];
        
                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",
                            "remove": {
                                "products": products
                            }
                        }
                    });
                });
        },

        qty: ({ commit, dispatch }, payload) => {
            let params = {
                id: payload.id,
                qty: payload.qty,
            };

            axios.put('/ajax/cart/qty', params)
                .then(request => {
                    commit('setQty', { id: payload.id, set_id: payload.set_id, qty: request.data.qty });
                    dispatch('getCart');
                });
        },
    },
    getters: {
        amount: state => {
            return state.amount;
        },
        oldAmount: state => {
            return state.oldAmount;
        },
        discount(state) {
            let discount = state.oldAmount - state.amount;

            return discount;
        },
        qty(state) {
            return state.items.length;
        },
    },
}